import { Box, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ConfirmStatus,
  FormClassApply,
  Status,
} from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkTitle from "../../components/atoms/TkTitle";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkDataTable from "../../components/molecules/TkDataTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { changeAmountFormat } from "../../utils/useTools";
import "./_style.scss";
import { httpAPI_APP013, httpAPI_PRE008 } from "./api/request";
import { funPremiumFacilityBodyList, makeHeadList } from "./hooks/useHooks";
import TkButton from "../../components/atoms/TkButton";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import { TkGetCode } from "../../utils/TkGetCode";

/**
 * SCRW080003 掛金情報確認　施設一覧
 * @Todo APIは未設計のため仮決め 設計書確定時に再度見直し
 * @return SCRW080003 掛金情報確認　施設一覧
 */
const SCRW080003 = () => {
  let location = useLocation();
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const [premiumSum, setPremiumSum] = useState<number>(0);
  const [infoTableList, setInfoTableList] = useState<any[]>([]);
  const [header, setHeader] = useState<any>([]);
  const [showButton, setShowButton] = useState(false);
  const [applyId, setApplyId] = useState<number>();
  const contractorNo =
    businessState.common?.contractorNo || location?.state?.contractorNo;
  const contractorName =
    (contractorNo ?? "") + ":" + businessState.common?.contractorName;
  const [fileData, setFileData] = useState<any>();

  async function openingScreen() {
    try {
      // 掛金納付対象職員届参照API 呼び出し
      const res = await httpAPI_PRE008({ applyId: location.state?.applyId });

      if (res.resultCd === "I0000") {
        setApplyId(res.applyId);

        const infoBodyList: any[] = funPremiumFacilityBodyList(
          res.facilityList,
          res.year as number,
          setPremiumSum
        );
        setInfoTableList(infoBodyList);

        setHeader(makeHeadList(res.unitPremiumAmt ?? 0));

        let showFlg =
          res.latestApplyStatus !== Status["取下済"] &&
          res.year! === state.authInfo?.fiscalYear! &&
          state.authInfo?.confirmStatus === ConfirmStatus["確定中"];
        setShowButton(showFlg);

        let file = res.formList?.find(
          (item) => item.formClass === FormClassApply["掛金納付対象職員届"]
        );
        if (file) {
          let fileData = {
            dataname: TkGetCode(FormClassApply, file.formClass),
            base64filedata: file.fileBase64,
          };
          setFileData(fileData);
        }

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  }

  useEffect(() => {
    //初期表示
    openingScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRemand = async () => {
    // 掛金届の再提出API 呼び出し
    try {
      const res = await httpAPI_APP013({ applyId });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRW080003PageForTest" className="tkSCRW080003">
      <TkKikoStepper
        applicationFlowType={"TYPE4"}
        businessType="JOB-11"
        applicationStatus={Status["処理完了"]}
      />
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW080003_01}</TkInfoManual>

      <TkContractorAndNumberLine name="契約者（法人）名" no={contractorName} />

      <TkTitle>
        {"納付する掛金額合計:" + changeAmountFormat(premiumSum) + "円"}
      </TkTitle>
      <Typography>{"※5月31日までに納付してください。"}</Typography>
      <TkDataTable
        headList={header}
        bodyList={infoTableList}
        count={infoTableList.length}
        defaultRowsPerPage={10}
        showUnit
      />

      {fileData && <TkDownloadLink downloadBase64 {...fileData} />}

      <Box className="tkDisplay">
        <TkBackButton
          useBackParam
          navigateParam={{
            applyId,
            contractorNo,
          }}
        />
        {showButton && (
          <TkButton onClick={handleRemand}>契約者に差戻し</TkButton>
        )}
      </Box>
    </Box>
  );
};

export default SCRW080003;
